import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AppInsightsService {
    private appInsights: ApplicationInsights;

    constructor() {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: environment.azure.app_insights.instrumentation_key,
                enableAutoRouteTracking: true
            }
        });
        this.appInsights.loadAppInsights();
        this.appInsights.trackPageView();
    }

    // --------------------------------------------------------------------------------------------------------------------
    /** Tracks a page view. This method is used to manually record a page view in the Application Insights service. */
    // --------------------------------------------------------------------------------------------------------------------
    trackPageView(name?: string, uri?: string, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) {
        this.appInsights.trackPageView({ name, uri, properties, measurements });
    }

    // --------------------------------------------------------------------------------------------------------------------
    /**  Tracks an event. This method is used to manually record an event in the Application Insights service. */
    // --------------------------------------------------------------------------------------------------------------------
    trackEvent(name: string, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) {
        this.appInsights.trackEvent({ name, properties, measurements });
    }

    // --------------------------------------------------------------------------------------------------------------------
    /** Tracks an exception. This method is used to manually record an exception in the Application Insights service. */
    // --------------------------------------------------------------------------------------------------------------------
    trackException(exception: Error, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) {
        this.appInsights.trackException({ error: exception, properties, measurements });
    }

    // --------------------------------------------------------------------------------------------------------------------
    /** Tracks a trace message. This method is used to manually record a trace message in the Application Insights service. */
    // --------------------------------------------------------------------------------------------------------------------
    trackTrace(message: string, properties?: { [key: string]: any }, measurements?: { [key: string]: number }) {
        this.appInsights.trackTrace({ message, properties, measurements });
    }

    // --------------------------------------------------------------------------------------------------------------------
    /** Tracks a metric. This method is used to manually record a metric in the Application Insights service. */
    // --------------------------------------------------------------------------------------------------------------------
    trackMetric(name: string, average: number, sampleCount?: number, min?: number, max?: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name, average, sampleCount, min, max, properties });
    }
}
